// src/hooks/useModal.js
import { useState } from 'react';

const useModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [action, setAction] = useState(null);

  const showModal = (actionHandler) => {
    setAction(() => actionHandler);
    setIsVisible(true);
  };

  const hideModal = () => {
    setIsVisible(false);
    setAction(null);
  };

  const confirmAction = () => {
    if (action) action();  // Execute the action passed to the modal
    hideModal();  // Close the modal after confirmation
  };

  return {
    isVisible,
    showModal,
    hideModal,
    confirmAction,
  };
};

export default useModal;
